import {Component, ElementRef, inject, ViewChild} from '@angular/core';
import {NavHeaderComponent} from "../nav-header/nav-header.component";
import {FooterComponent} from "../footer/footer.component";
import {TechnologiesStore, TechnologyStack} from "./store/tech-store";
import {DotsLoaderComponent} from "../../../../core/helper-components/dots-loader/dots-loader.component";
import {DisplayEnums} from "../../../../core/constants/display.enums";
@Component({
  selector: 'app-tech-stack',
  templateUrl: './tech-stack.component.html',
  imports: [
    NavHeaderComponent,
    FooterComponent,
    DotsLoaderComponent
  ],
  styleUrls: ['./tech-stack.component.scss'],
  providers: [TechnologiesStore]
})
export class TechStackComponent {

  readonly #store: any = inject(TechnologiesStore);
  protected readonly error = this.#store.error;
  protected readonly isLoading = this.#store.isLoading;

  protected readonly technologies = this.#store.groupedByStack;

  protected reload(): void {
    this.#store.reload();
  }

  @ViewChild('section') section!: ElementRef;

  scrollToSection() {
    this.section.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  getStackLabel(stack: TechnologyStack): string {
    return DisplayEnums.TechStack[stack] ?? '';
  }

  protected readonly TechnologyStack = TechnologyStack;
  protected readonly DisplayEnums = DisplayEnums;
}
